import { Footer } from "@/shared/components/Footer";
import { Hero } from "@/features/home/sections/Hero";
import { Results } from "@/features/home/sections/Results";
import { Cases } from "@/features/home/sections/Cases";
import { Approach } from "@/features/home/sections/Approach";
import { Method } from "@/features/home/sections/Method";
import { Workshops } from "@/features/home/sections/Workshops";
import { Articles } from "@/features/home/sections/Articles";
import { Testimonials } from "@/features/home/sections/Testimonials";
import { Contact } from "@/features/home/sections/Contact";

export function HomePage() {
  return (
    <>
      <main>
        <Hero />
        <Results />
        <Cases />
        <Approach />
        <Method />
        <Workshops />
        <Articles />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
